import { selectModules } from "./modules";
import { createAppSelector } from "./util";

const DEFAULT_APPS = [
  "Advertising",
  "Merchandising",
  "Pricing",
  "Growth",
  "Admin",
  "Reports",
  "Placement",
  "Promotions",
  "Main",
  "Product",
  "Workflows",
];

export const selectApplications = createAppSelector([(state) => selectModules(state)], (modules) => {
  const searchAnalyticsModule = modules.find((m) => m.name === "SEARCH_ANALYTICS");

  if (searchAnalyticsModule?.settings?.only) {
    return ["Search Analytics"];
  }

  if (searchAnalyticsModule) {
    return [...DEFAULT_APPS, "Search Analytics"];
  }

  return DEFAULT_APPS;
});
